module.exports = __webpack_public_path__ + "media/images/application/icons/double-caret-b945615ed1fada082cea647d22a2ca6a.svg";